var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraRelease({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#546m4mtata)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.552 7.553 8 0 .447 7.553a.634.634 0 0 0 0 .895L8 16.001l7.552-7.553a.634.634 0 0 0 0-.895zM8 10.365 5.634 8 8 5.634 10.365 8 8 10.365z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.65A3.983 3.983 0 0 1 7.982.035L2.791 5.194 5.608 8.01 8 5.65z",
    fill: "url(#fcepa1sitb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.371 7.993 8 10.365A3.983 3.983 0 0 1 8 16l5.187-5.187-2.816-2.819z",
    fill: "url(#3vkrhkl8yc)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcepa1sitb",
    x1: 7.578,
    y1: 3.242,
    x2: 4.275,
    y2: 6.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3vkrhkl8yc",
    x1: 8.451,
    y1: 12.731,
    x2: 11.748,
    y2: 9.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "546m4mtata"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraRelease);
export default __webpack_public_path__ + "static/media/jira-release.bf719da53c955f7f9f777be5cb187f57.svg";
export { ForwardRef as ReactComponent };